import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { SupervisiIbsObservasi } from "@/types/SupervisiIbs";

export interface SupervisiIbsListFilter {
  tanggal_dari?: string;
  tanggal_sampai?: string;
  jenis_supervisi?: string;
  signed?: boolean;
  page?: number;
  per_page?: number;
}

async function list(params: SupervisiIbsListFilter = {}) {
  const response = await http
    .getDataParam("/supervisi-ibs", { params })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function find(id: number) {
  const response = await http.getData(`/supervisi-ibs/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function create(data: any) {
  const response = await http.postData("/supervisi-ibs", data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function update(id: number, data: any) {
  const response = await http.putData(`/supervisi-ibs/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

async function updateItems(
  id: number,
  items: Array<{
    id: number;
    hasil?: "ya" | "tidak" | "na" | null;
    masalah?: string | null;
    rekomendasi?: string | null;
  }>
) {
  const response = await http
    .putData(`/supervisi-ibs/${id}/items`, { items })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function updateObservasi(id: number, observasi: SupervisiIbsObservasi[]) {
  const response = await http
    .putData(`/supervisi-ibs/${id}/observasi`, { observasi })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signSupervisor(id: number, data: { password: string }) {
  const response = await http
    .putData(`/supervisi-ibs/${id}/sign-supervisor`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKepalaUnit(id: number, data: { password: string }) {
  const response = await http
    .putData(`/supervisi-ibs/${id}/sign-kepala-unit`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function signKetuaPpi(id: number, data: { password: string }) {
  const response = await http
    .putData(`/supervisi-ibs/${id}/sign-ketua-ppi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });
  return response;
}

async function destroy(id: number) {
  const response = await http.deleteData(`/supervisi-ibs/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);
    return Promise.reject(err);
  });
  return response;
}

function printPdf(id: number) {
  window.open(`${http.getAPI()}/supervisi-ibs/${id}/pdf`, "_blank");
}

export default {
  list,
  find,
  create,
  update,
  updateItems,
  updateObservasi,
  signSupervisor,
  signKepalaUnit,
  signKetuaPpi,
  destroy,
  printPdf,
};
